export const DISPATCH_MODE = {
  SELF: 'SELF',
  COURIER: 'COURIER'
};

export const DISPATCH_MODE_OPTIONS = [
  { value: DISPATCH_MODE.SELF, label: 'Self' },
  { value: DISPATCH_MODE.COURIER, label: 'Courier' }
];

export const isSelfDispatchMode = (dispatchMode) => dispatchMode === DISPATCH_MODE.SELF;

export const dispatchModeLabel = (dispatchMode) =>
  DISPATCH_MODE_OPTIONS.find((option) => option.value === dispatchMode)?.label || null;

/**
 * Infer Self vs Courier from the persisted transporter string (dispatch_mode is request-only).
 * Blank transporter → null. Case/whitespace-insensitive match to vendor name → Self; otherwise Courier.
 */
export const inferDispatchMode = (transporterName, vendorName) => {
  if (!transporterName?.trim()) {
    return null;
  }
  if (!vendorName?.trim()) {
    return DISPATCH_MODE.COURIER;
  }
  return transporterName.trim().toLowerCase() === vendorName.trim().toLowerCase()
    ? DISPATCH_MODE.SELF
    : DISPATCH_MODE.COURIER;
};

/** Saved dispatch transporter matches the seller name, so delivery must stay Self. */
export const wasDispatchedAsSelf = (transporterName, vendorName) =>
  inferDispatchMode(transporterName, vendorName) === DISPATCH_MODE.SELF;

/** MDM `GET /transport` returns transporters newest-updated first; dropdowns show them by name. */
export const sortTransportersByName = (transporters) =>
  [...(transporters ?? [])].sort((a, b) =>
    (a?.registered_transport_name || '').localeCompare(b?.registered_transport_name || '')
  );
